<find-item
  [hideForm]="true"
  [showExport]="false"
  [showAdditionalColumns]="false"
  [searchObservableFunc]="mS.searchNotificationReceivers"
  [displayedColumns]="columns()"
  orderBy="createdOn"
  orderDirection="desc" />
